// import apis from '@/apis';
// import { useNavigate, useLocation } from 'react-router-dom'
// import { useUserInfoStore } from '@/stores'
import { Navigate } from 'react-router-dom'
// import { useEffect, useState } from 'react'
import { useUserInfo } from '@/hooks/userContext'
import router from '@/router'
import type { Route } from '@/types/common'
import { storageUtil, routesMap, utils } from '@/utils'

const { getUrlParameters, objectToQueryString } = utils
// const { user: userApi } = apis
function RouterGuard({ children }: any) {
  // const userInfoStore = useUserInfoStore();
  const currentPath = window.location.pathname
  const routerItem: Route = (router.routes.find(
    (item: any) => item.path === currentPath,
  ) as unknown as Route) ?? { name: '', element: null, path: currentPath }
  const accessToken = storageUtil.getSessionStorage('accessToken')
  const uid = storageUtil.getSessionStorage('uid')
  const { userInfo, loading } = useUserInfo()
  const urlParame: any = getUrlParameters(location.search)

  if (['AgentCoin', 'AgentTransferRrecord'].includes(routerItem.name)) {
    if (!accessToken || !uid) {
      // 根据配置决定是否跳转登录页
      if (!utils.shouldRedirectToLogin()) {
        return children
      }
      const search = objectToQueryString({
        ...urlParame,
      })
      console.log('此时跳转登录页3', search)
      return <Navigate to={`${routesMap.Login}${search ? '?' + search : ''}`} replace />
      return children
    } else {
      return children
    }
  }

  // 如果数据还在加载，显示 loading 页面
  if (loading) return ''

  console.log('userInfo', userInfo)

  if (userInfo?.guildId > 0) {
    return children
  } else {
    let search = ''
    if (urlParame?.source === '0') {
      search = objectToQueryString({
        ...urlParame,
        source: 0,
      })
    } else {
      search = objectToQueryString({
        ...urlParame,
        source: 0,
        isClose: 1,
      })
    }

    // 没有加入公会跳转到公会列表
    return <Navigate to={`${routesMap.GuildList}?${search}`} replace />
  }
}

export default RouterGuard
